import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Pem {
  _id;
  user;
  cultura;
  etec;
  estado;
  cidade;
  nome;
  produtor;
  data;
  createdAt;
  updatedAt;
  deletedAt;
  hasBeenSent;
  hasBeenUpdated;

  /**
   *
   * @param {Object} data
   * @param {Boolean} data.hasBeenSent
   * @param {Boolean} data.hasBeenUpdated
   * @param {Number} data.user
   * @param {Number} data.cultura
   * @param {Number} data.etec
   * @param {Number} data.estado
   * @param {Number} data.cidade
   * @param {String} data.nome
   * @param {String} data.produtor
   * @param {String} data.data
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    console.log(findEarliestAvailableID(db, 'pems'));
    this._id = await findEarliestAvailableID(db, 'pems');
    return db.pems.put(this);
  }

  static describe = () =>
    '++_id, user, cultura, etec, estado, cidade, nome, produtor, data, hasBeenSent, createdAt, updatedAt, deletedAt';
}
